import { AI_RESPONSE_SOURCE_GROUPING_IDS, AI_RESPONSE_SOURCE_IDS } from './account-models';
import { ReactComponent as HackettIp } from '@/assets/icons/hackettip.svg';
import { ReactComponent as GenAi } from '@/assets/icons/genai.svg';
import { QuestionCircleFill } from 'react-bootstrap-icons';

export interface AiConversationListItem {
	aiConversationId: string;
	title: string;
}

export interface AiConversation extends AiConversationListItem {
	conversationQueries: ConversationQuery[];
}

export interface ReportAiConversationMetadata {
	conversationInitiatedAt: string;
}

export interface ReportAiConversationResponse {
	aiConversation: AiConversation;
	reportMetadata: ReportAiConversationMetadata;
}

export interface AiConversationSections {
	[x: string]: AiConversationListItem[];
}

export interface ConversationQuery {
	aiConversationId: string;
	aiResponseSourceGroupingId: AI_RESPONSE_SOURCE_GROUPING_IDS;
	aiResponseSourceIds: AI_RESPONSE_SOURCE_IDS[];
	conversationQueryId: string;
	created: string;
	displayOrder: number;
	hasRating: boolean;
	query: string;
	queryResponse: string;
	streamStatus?: string;
	streamEndReason?: string;
	streamCompletedAt?: string;
	ticket?: string;
}

export interface ParsedQueryResponse {
	answer: string;
	citations: TempCitation[];
	followUpQuestionsSuggestions: FollowUpQuestionSuggestion[];
	references: string[];
	showMore: boolean;
	typeOfData: string;
}

export interface TicketQuery extends ConversationQuery {
	created: string;
	ticket: string;
}

export interface TempResponse {
	answer: string;
	references?: string[];
	citations: TempCitation[];
	followUpQuestionsSuggestions?: FollowUpQuestionSuggestion[];
	showMore?: boolean;
	typeOfData?: string;
	answerBySources?: AnswerBySource[];
}

export interface AnswerBySource {
	source: AI_RESPONSE_SOURCE_IDS;
	content: string;
}

export interface FollowUpQuestionSuggestion {
	suggestionId: string;
	suggestionRound: number;
	suggestion: string;
	suggestionAction: string;
	originalQuery: string;
}

export interface TempCitation {
	documentTitle: string;
	documentUrl: string;
}

export enum FEEDBACK_RATING_ID {
	NEGATIVE = 'NEGATIVE',
	NEUTRAL = 'NEUTRAL',
	POSITIVE = 'POSITIVE',
}

export const individualResponseSourceOptions = [
	{
		aiResponseSourceId: AI_RESPONSE_SOURCE_IDS.HACKETT_IP,
		title: 'Hackett IP',
		description: 'Currently includes Advisory Research, Best Practices & Select Metrics',
		icon: HackettIp,
	},
	{
		aiResponseSourceId: AI_RESPONSE_SOURCE_IDS.INQUIRIES,
		title: 'Advisory Inquiries',
		description: 'Based on Advisory produced Inquiry reports for clients',
		icon: QuestionCircleFill,
	},
	{
		aiResponseSourceId: AI_RESPONSE_SOURCE_IDS.WEB,
		title: 'LLM (Public Domain)',
		description: 'Based on LLM public-domain trained data',
		icon: GenAi,
	},
];

export const isAskHackettSourceSelectionLocked = (aiResponseSourceIds: AI_RESPONSE_SOURCE_IDS[]) =>
	aiResponseSourceIds.length === 1 && aiResponseSourceIds[0] === AI_RESPONSE_SOURCE_IDS.HACKETT_IP;
